export const errorCodes = {
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    NOT_PAID_COD: 'NOT_PAID_COD',
};
